import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { FormViewDrilldownRoutingService } from './form-view-drilldown-routing.service';

/** `#popup?...` must not hit the `**` → home wildcard (legacy ui-router otherwise). */
@Injectable({ providedIn: 'root' })
export class FormViewDrilldownRedirectGuard implements CanActivate {
  constructor(
    private router: Router,
    private drilldownRouting: FormViewDrilldownRoutingService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): UrlTree | boolean {
    const params = this.drilldownRouting.mergeDrilldownParams(route);
    const isState = this.drilldownRouting.inferIsStateFromContext();
    const returnRoute = this.drilldownRouting.rememberReturnRouteFromUrl(
      typeof window !== 'undefined' ? window.location.href : '',
      isState
    );
    if (params) {
      this.drilldownRouting.queuePendingDrilldown(params, { returnRoute, isState });
    }

    // Legacy: stay on Form Review shell — `form-view.dashboard` — then open element-view tab.
    return this.drilldownRouting.createDashboardUrlTree(isState);
  }
}

/** `#/home?element_name=...` PDF stray links → form-view dashboard (not home shell). */
@Injectable({ providedIn: 'root' })
export class FormViewDrilldownHomeGuard implements CanActivate {
  constructor(private drilldownRouting: FormViewDrilldownRoutingService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const params = this.drilldownRouting.mergeDrilldownParams(route);
    if (!params?.['element_name']) {
      return true;
    }

    const isState = this.drilldownRouting.inferIsStateFromContext();
    const returnRoute = this.drilldownRouting.getDefaultFormViewRoutePath(isState);
    this.drilldownRouting.queuePendingDrilldown(params, { returnRoute, isState });

    return this.drilldownRouting.createDashboardUrlTree(isState);
  }
}
